/**
 * Random, URL-safe IDs for maps, goals and blocks. 128 bits of randomness, base64url encoded, so a
 * map ID in a join link cannot be guessed. Uses Web Crypto, available in browsers and Node 22.
 */
export type IdGenerator = (prefix?: string) => string;

const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";

// Typed narrowly so this package needs neither DOM nor Node type definitions.
const webCrypto = (
  globalThis as unknown as { crypto: { getRandomValues(a: Uint8Array): Uint8Array } }
).crypto;

/** Unpadded base64url of 16 random bytes: 22 characters. */
export const newId: IdGenerator = (prefix = "") => {
  const bytes = webCrypto.getRandomValues(new Uint8Array(18)).subarray(0, 16);
  let out = "";
  let bits = 0;
  let acc = 0;
  for (const b of bytes) {
    acc = (acc << 8) | b;
    bits += 8;
    while (bits >= 6) {
      bits -= 6;
      out += ALPHABET[(acc >> bits) & 63];
    }
  }
  if (bits > 0) out += ALPHABET[(acc << (6 - bits)) & 63];
  return prefix + out;
};
